import { connect } from 'react-redux';

import createCommentAction from '../../../../../../../../core/actions/comment/create';
import { getComment } from '../../../../../../../../core/selectors/comments';

import CreateCommentFeed from './CreateComment';

const isInInbox = (location) => {
  const query = (location && location.query) || {};
  return !!query.inbox;
};

const mapStateToProps = (state, ownProps) => ({
  user: state.user.user,
  parentComment: getComment(state, ownProps.parent),
  isCreatingComment: state.comment.isCreatingComment,
  isInInbox: isInInbox(state.routing.locationBeforeTransitions),
});

const mapDispatchToProps = (dispatch) => ({
  createComment: (commentData) =>
    new Promise((resolve, reject) => {
      const result = dispatch(createCommentAction(commentData));
      if (!result) {
        reject();
        return;
      }
      result.then((c) => resolve(c));
    }),
});

const CreateCommentFeedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCommentFeed);

export default CreateCommentFeedContainer;
